import React, { useEffect } from "react";
import { X } from "lucide-react";
import { cn } from "../../lib/utils";
import { Button } from "./button";

const BottomSheet = ({
  open,
  onClose,
  title,
  children,
  primaryAction,
  secondaryAction,
  className,
  overlayClassName,
  /** Lift sheet above pub sticky call bar + optional bottom nav (public QR pages). */
  reserveBottomChrome = false,
}) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose?.();
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className={cn(
        "fixed inset-0 z-[100] flex items-end sm:items-center justify-center bg-black/50 p-0 sm:p-4",
        overlayClassName
      )}
      onClick={onClose}
      role="dialog"
      aria-modal="true"
    >
      <div
        className={cn(
          "bg-white w-full max-w-sm sm:rounded-lg rounded-t-lg shadow-lg flex flex-col max-h-[min(90vh,100%)] pb-[env(safe-area-inset-bottom)]",
          reserveBottomChrome &&
            "mb-[calc(4.75rem+72px+env(safe-area-inset-bottom,0px))] sm:mb-0",
          !reserveBottomChrome && "mb-[calc(4.75rem+env(safe-area-inset-bottom,0px))] sm:mb-0",
          className
        )}
        onClick={(e) => e.stopPropagation()}
      >
        {(title || onClose) && (
          <div className="flex shrink-0 items-center justify-between px-4 py-3 border-b border-slate-100">
            {title ? <h2 className="text-lg font-bold text-slate-900">{title}</h2> : <span />}
            {onClose && (
              <button
                type="button"
                onClick={onClose}
                className="min-h-12 min-w-12 flex items-center justify-center rounded-lg hover:bg-slate-100"
                aria-label="Close"
              >
                <X size={20} />
              </button>
            )}
          </div>
        )}
        <div className="min-h-0 flex-1 overflow-y-auto p-4">{children}</div>
        {(primaryAction || secondaryAction) && (
          <div className="flex shrink-0 gap-3 border-t border-slate-100 bg-white p-4">
            {secondaryAction && (
              <Button variant="outline" fullWidth onClick={secondaryAction.onClick}>
                {secondaryAction.label}
              </Button>
            )}
            {primaryAction && (
              <Button variant={primaryAction.variant || "primary"} fullWidth onClick={primaryAction.onClick}>
                {primaryAction.label}
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default BottomSheet;
